import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function AdminDashboard() {
  const { t } = useLang();
  const [stats, setStats] = useState({ projects: 0, bookings: 0, messages: 0, txs: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/projects"),
      api.get("/admin/bookings"),
      api.get("/admin/contact-messages"),
      api.get("/admin/transactions"),
    ])
      .then(([p, b, m, x]) =>
        setStats({
          projects: p.data.length,
          bookings: b.data.length,
          messages: m.data.length,
          txs: x.data.length,
        })
      )
      .catch(() => {});
  }, []);

  const cards = [
    { label: t("admin.projects"), value: stats.projects },
    { label: t("admin.bookings"), value: stats.bookings },
    { label: t("admin.messages"), value: stats.messages },
    { label: t("admin.transactions"), value: stats.txs },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-4xl text-ink mb-10">{t("admin.dashboard")}</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div
            key={c.label}
            data-testid={`admin-stat-${c.label}`}
            className="bg-bg-surface border border-edge p-6"
          >
            <p className="text-eyebrow text-ink-muted">{c.label}</p>
            <p className="font-display text-5xl text-brand mt-3">{c.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
